import { Chat } from 'pcln-icons';
import React from 'react';
import { FloatingActionButton } from '../FloatingActionButton/FloatingActionButton';
/**
 * @public
 */
export function ChatTrigger(props) {
  return React.createElement(FloatingActionButton, {
    bottom: 0,
    icon: Chat,
    right: 0,
    ...props
  });
}